import React from 'react';
import InViewObserver from 'components/InViewObserver';
import NewStoryCard from 'components_v2/desktop/NewStoryCard';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import s from './CardGrid.scss';
import Listingheader from '../../../../../../src/routes/home/components/common/ListingheaderV2';

const renderStoryCard = (story, index, ga4Type, ga4Category, isLarge) => (
  <NewStoryCard
    title={story.title || story.hl}
    msid={story.msid || story.imageid}
    isBigHeading={isLarge}
    isLarge={isLarge}
    cardType="card_20"
    wu={story.link || story.wu}
    ga4Type={ga4Type}
    ga4Category={ga4Category}
    gaIndex={index}
    imagesize={story?.imagesize}
  />
);

const CardGrid = ({
  items,
  heading = 'Related Articles',
  ga4Type = '',
  ga4Category = '',
  data = '',
}) => {
  if (!(Array.isArray(items) && items.length)) {
    return null;
  }

  const onView = () => {
    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: ga4Type,
      });
    }
  };

  return (
    <InViewObserver inViewCallback={onView}>
      <div className={s.secWrap}>
        <Listingheader headingname={heading} subheading={data?.moreText} />
        <div className={s.colWrap}>
          {items &&
            Array.isArray(items) &&
            items.length && (
              <ul className={s.colLeft} key="colLeft">
                <li key={items[0].id}>
                  {renderStoryCard(items[0], 0, ga4Type, ga4Category, true)}
                </li>
              </ul>
            )}
          {items &&
            Array.isArray(items) &&
            items.length > 1 && (
              <ul className={`${s.gridView} ${s.colRight}`} key="colRight">
                {items.map((it, index) => {
                  if (index > 0 && index < 5) {
                    return (
                      <li key={it.id}>
                        {renderStoryCard(
                          it,
                          index,
                          ga4Type,
                          ga4Category,
                          false,
                        )}
                      </li>
                    );
                  }
                  return null;
                })}
              </ul>
            )}
        </div>
      </div>
    </InViewObserver>
  );
};
export default CardGrid;
